import React, { Fragment } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { instanceOf, bool, number, func } from 'prop-types';
import { List as ImmutableList, Map } from 'immutable';

import { translateProductNameCallback } from '../../../../../helpers/i18n';
import Tag from '../../../../Base/Tag';
import List from '../../../../Element/List';

const SessionCandidateIdentity = ({ candidate, isMissing }) => {
  const { i18n, t } = useTranslation();
  const translateProductName = translateProductNameCallback(i18n, t);

  const productsAndServices = ImmutableList(
    candidate
      .get('productsAndServices')
      .map(
        (productsAndService) =>
          productsAndService.get('quantity') + ' ' + translateProductName(productsAndService.get('translationKey')),
      ),
  );

  return (
    <Fragment>
      <p className="account-session-candidate__name">
        {candidate.get('firstname')} {candidate.get('lastname')}
        {isMissing && (
          <Tag className={'tag--canceled'}>
            <Trans>account.sessions.candidate.status.missing</Trans>
          </Tag>
        )}
      </p>
      <p className="account-session-candidate__email">{candidate.get('email')}</p>
      <List items={productsAndServices} listClassNames={'account-session-candidate__options'} />
    </Fragment>
  );
};

SessionCandidateIdentity.propTypes = {
  candidate: instanceOf(Map),
  isMissing: bool,
  hasPhoto: bool,
  sessionId: number,
  reFetchCandidates: func,
  past: bool,
};

export default SessionCandidateIdentity;
